import actions from './actions';

const initialState = {
    insumos: [],
    currentInsumo: null,
    currentProceso: null,
    inventario: [],
    initialInventario: false,
    loadingInventario: false,
};

export default function productoReducer(state = initialState, action) {
    switch (action.type) {
        case actions.GET_INSUMOS_SUCCESS:
            return {
                ...state,
                insumos: action.payload,
            }
        case actions.CREATE_INSUMO_SUCCESS:
            return {
                ...state,
                insumos: [...state.insumos, action.payload]
            }
        case actions.EDIT_INSUMO_SUCCESS:
            return {
                ...state,
                insumos: state.insumos.map(insumo => insumo._id === action.payload._id ? action.payload : insumo)
            }
        case actions.DELETE_INSUMO_SUCCESS:
            return {
                ...state,
                insumos: state.insumos.filter(insumo => insumo._id !== action.payload)
            }
        case actions.SET_CURRENT_INSUMO:
            return {
                ...state,
                currentInsumo: action.payload
            }
        case actions.CLEAR_CURRENT_INSUMO:
            return {
                ...state,
                currentInsumo: null
            }
        case actions.SET_CURRENT_PROCESO:
            return {
                ...state,
                currentProceso: action.payload
            }
        case actions.CLEAR_CURRENT_PROCESO:
            return {
                ...state,
                currentProceso: null
            }
        case actions.GET_REGISTRO_SUCCESS:
            return {
                ...state,
                inventario: action.payload,
            }
        default:
            return state;
    }

}
